<form [formGroup]="searchForm" class="mat-filter" [ngStyle]="{'background-color': color ? color : 'white'}">
  <div>
    <input #input class="mat-filter-input" matInput placeholder="{{placeholder}}" formControlName="value"
      (keydown)="handleKeydown($event)">
    <mat-spinner *ngIf="localSpinner" class="spinner" diameter="16"></mat-spinner>
  </div>
  <div *ngIf="noResults" class="noResultsMessage">
    {{noResultsMessage}}
  </div>
</form>